import React, { useRef, useState } from "react";
import { Check, Pause, Play, X } from "lucide-react";
import { API, SERIF } from "./practiceApi";
import { DONE_GREEN } from "./PracticeDots";

// Day 21: a warm celebration — 21 dots bloom green one by one, and Adelaida's voice note.
export const CompleteNote = ({ onDismiss }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const toggle = () => { const a = ref.current; if (a.paused) a.play().catch(() => {}); else a.pause(); };
  return (
    <div className="relative overflow-hidden rounded-2xl border p-5 pr-10" style={{ borderColor: `${DONE_GREEN}66`, background: "linear-gradient(135deg, rgba(63,191,127,0.14), rgba(215,187,122,0.08))" }} data-testid="practice-complete-note">
      <style>{"@keyframes pc-bloom{0%{transform:scale(0);opacity:0}70%{transform:scale(1.25);opacity:1}100%{transform:scale(1);opacity:1}}"}</style>
      <button type="button" onClick={onDismiss} aria-label="Dismiss" data-testid="practice-complete-dismiss" className="absolute right-3 top-3 text-[#b9ad8f] transition-colors hover:text-[#f3ecd9]"><X size={16} /></button>
      <p className="text-[0.62rem] uppercase tracking-[0.28em]" style={{ color: DONE_GREEN }}>21 days · a note from Adelaida</p>
      <div className="mt-4 grid grid-cols-7 gap-2 max-w-[15rem]" aria-hidden>
        {Array.from({ length: 21 }).map((_, i) => (
          <span key={i} className="inline-flex h-6 w-6 items-center justify-center rounded-full" style={{ background: DONE_GREEN, animation: `pc-bloom .55s ease-out ${0.12 + i * 0.07}s both` }}>
            <Check size={12} strokeWidth={3} className="text-white" />
          </span>
        ))}
      </div>
      <p className="mt-5 text-2xl text-[#f3ecd9]" style={{ fontFamily: SERIF }}>Twenty-one days. You did it.</p>
      <div className="mt-3 flex items-center gap-3">
        <button type="button" onClick={toggle} aria-label={playing ? "Pause" : "Play"} data-testid="practice-complete-play"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-[#0b1a33] transition-opacity hover:opacity-90" style={{ background: DONE_GREEN }}>
          {playing ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
        </button>
        <p className="text-base italic text-[#e9e2d0]" style={{ fontFamily: SERIF }}>You kept coming back to these words. Notice what feels different now.</p>
      </div>
      <audio ref={ref} src={`${API}/api/practice/complete-audio`} preload="none" onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
    </div>
  );
};
